import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function createCoBroker({
	name,
	email,
	phoneNumber,
	address,
	commissionPercentage,
	assignedLots,
	salesAgency,
	numberOfLotsAllowed,
}) {
	try {
		const randomPassword = Math.random().toString(36).slice(2);

		let creatUserAccount = firebase
			.functions()
			.httpsCallable('createUserAccountWithEmailAddPassword');
		let currentUserId = await creatUserAccount({
			email: email,
			password: randomPassword,
			displayName: name,
		});

		let user = firebase.database().ref('/users/' + currentUserId.data);
		await user.set({
			email: email,
			phoneNumber: phoneNumber,
			fullName: name,
			avatarCode: 'undefined',
			project_code: projectCode,
			projectRoles: {
				[projectCode]: 'cobroker',
			},
			initialPassword: randomPassword,
			createdAt: new Date().getTime(),
		});

		let coBrokerRef = firebaseRef.ref('/kavtek_coBrokers/' + projectCode);
		let newCoBrokerRef = await coBrokerRef.push();
		await newCoBrokerRef.set({
			id: '',
			email: email,
			phoneNumber: phoneNumber,
			address: address,
			commissionPercentage: commissionPercentage,
			numberOfLotsAllowed: numberOfLotsAllowed,
			salesAgency: salesAgency,
			userId: currentUserId.data,
		});

		assignedLots.forEach(async (lot) => {
			let lotRef = firebaseRef.ref(
				'/kavtek_lots/' + projectCode + '/' + lot
			);
			await lotRef.update({
				assignedCoBroker: newCoBrokerRef.key,
			});
		});
	} catch (error) {
		throw error;
	}
}
